import { render, staticRenderFns } from "./LanguageSelectorPublic.vue?vue&type=template&id=aec57fee&scoped=true"
import script from "./LanguageSelectorPublic.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorPublic.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectorPublic.vue?vue&type=style&index=0&id=aec57fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec57fee",
  null
  
)

export default component.exports